import checkOperation from './helpers/check-operation';
import checkEntity from './helpers/check-entity';
import checkOptions from './helpers/check-options';
import DefaultOptions from './helpers/default-options';
import isPlainObject from './helpers/is-plain-object';
import Transaction from './transaction';
import Queue from './queue';

export default function enqueue(...args) {
  try {
    // support the call style of only passing in an options
    // object that contains the operation and entity
    const operation = args[0];
    const entity = args[1];
    const opts = args[2];

    if (args.length === 1 && isPlainObject(operation)) {
      return enqueue(operation.operation, operation.entity, operation);
    }

    checkOperation(operation);
    checkEntity(entity);
    checkOptions(opts);

    const options = { ...DefaultOptions, ...opts };
    const tx = new Transaction(operation, entity, options);
    const queue = Queue.forEntity(entity.id, options.schemaName);

    return queue.append(tx);
  } catch (error) {
    console.error(error); // eslint-disable-line
    throw error;
  }
}
